import React from 'react';
import myImage from '../../assets/testimonial.jpg';
import myImage1 from '../../assets/chacha.jpeg';
import { FaStar } from 'react-icons/fa';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const Testimonial = () => {
  const data = [
    {
      review: 'The whole app development was just seamless. From start to finish, the team did a great job.',
      img: myImage,
      name: 'Emily Smith, Marketing Director at Growthify Solutions',
    },
    {
      review: 'What distinguished RaftLabs from other providers was their fantastic ability to build real-time engagement-based products. We wanted to build a platform that was partly a social media channel and partly like Zoom where people could interact with each other in real-time, and they did an awesome job doing that.',
      img: myImage1,
      name: 'John Doe, CEO at TechStar Industries',
    },
    {
      review: 'The whole app development was just seamless. From start to finish, the team did a great job.',
      img: myImage,
      name: 'Emily Smith, Marketing Director at Growthify Solutions',
    },
    {
      review: 'The whole app development was just seamless. From start to finish, the team did a great job.',
      img: myImage,
      name: 'Emily Smith, Marketing Director at Growthify Solutions',
    },
  ];

  return (
    <div className="bg-[#81A094] pb-20 flex flex-col items-center justify-center">
      <div className="text-white pt-20 font-prime text-5xl font-bold">
        Customer Testimonials
      </div>
      <div className="text-lg font-medium font-prime mt-5 text-white mb-32">
        Loved by startups and scaleups
      </div>
      <div className="carousel-container w-full px-20">
        <Carousel
          showThumbs={false}
          showArrows={true}
          showStatus={false}
          infiniteLoop={true}
          emulateTouch={true}
          autoPlay={true}
          interval={3000}
          stopOnHover={true}
          centerMode={true}
          centerSlidePercentage={50}
        >
          {data.map((testimonial, index) => (
            <div key={index} className="flex items-center justify-center my-20 z-0">
              <div className="flex flex-col bg-clip-border rounded-3xl bg-white shadow-gray-900/20 shadow-md p-8 w-[571px] h-[571px] mt-10">
                <div className="w-[232px] h-[232px] bg-white rounded-full flex items-center justify-center p-3 mt-[-130px] ml-32">
                  <img src={testimonial.img} alt="phot" className="rounded-full object-cover h-52 w-52" />
                </div>
                <div className="flex flex-col gap-8">
                  <p className="font-prime font-medium italic mt-8 px-8">
                    {testimonial.review}
                  </p>
                  <div className="">
                    <p className='font-prime font-medium px-8'>{testimonial.name}</p>
                    <div className="flex flex-row items-center justify-center mt-3">
                      {[...Array(5)].map((_, starIndex) => (
                        <FaStar key={starIndex} size={20} className='text-yellow-400' />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Testimonial;
